import type { CallHistoryItem, CallStatus } from '../../types';

export const TERMINAL_CALL_STATUSES = new Set<CallStatus>([
  'completed',
  'no_interaction',
  'failed',
  'no_answer',
  'no_answer_timeout',
  'busy',
  'cancelled',
  'transfer_unanswered',
  'congestion',
  'voicemail',
  'invalid_number',
  'config_error',
  'declined',
  'unreachable',
  'timeout',
  'mismatch',
  'api_timeout',
  'terminated_manual',
]);

/**
 * Return whether live call controls should be hidden for the current call state.
 *
 * The detail drawer can receive lightweight observer updates before the follow-up
 * detail fetch completes. We therefore treat terminal statuses as closed even
 * when `endedAt` has not arrived in the local payload yet.
 */
export function isCallTerminalForControlPanel(
  call: Pick<CallHistoryItem, 'endedAt' | 'status'>,
): boolean {
  return Boolean(call.endedAt) || TERMINAL_CALL_STATUSES.has(call.status);
}
